import intl from "./staticIntl";
import { FormatMsg } from "../../hooks/useFormatMsg";

// eslint-disable-next-line import/prefer-default-export
export const formatMsg: FormatMsg = (intlId, values, concat = "") => {
  const { formatMessage } = intl;
  const translatedMsg = formatMessage({ id: intlId }, values ?? undefined);
  return translatedMsg.concat(concat);
};
